export default {"src":"/_next/static/media/WhoWeAre_016A.e14fd304.JPG","height":692,"width":1920};